export default "  // empty\n";
//# sourceMappingURL=lighting-common.glsl.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/shadertools/src/modules/lighting/lighting-common.glsl.js
// module id = 1577
// module chunks = 0